import { Building2 } from "lucide-react"
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import { EmptyState } from "@/components/empty-state"
import { FilterToolbar } from "@/components/filter-toolbar"
import { LoadingState } from "@/components/loading-state"
import { PageHeader } from "@/components/page-header"
import { CooperativeCard } from "@/features/cooperatives/components/cooperative-card"
import { useCooperatives } from "@/features/cooperatives/hooks/use-cooperatives"

export function CooperativesPage() {
  const { t } = useTranslation(["cooperatives", "common"])
  const { data: cooperatives, isLoading } = useCooperatives()
  const [search, setSearch] = useState("")

  const filtered = useMemo(() => {
    const lower = search.toLowerCase().trim()
    if (!lower) return cooperatives ?? []
    return (cooperatives ?? []).filter(
      (c) =>
        c.name?.toLowerCase().includes(lower) ||
        c.region?.toLowerCase().includes(lower)
    )
  }, [cooperatives, search])

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={t("title")}
        description={t("subtitle")}
        meta={
          cooperatives ? (
            <span className="text-sm text-muted-foreground">
              · {t("search.resultsCount", { count: filtered.length })}
            </span>
          ) : null
        }
      />

      <FilterToolbar
        search={search}
        onSearchChange={setSearch}
        searchPlaceholder={t("search.placeholder")}
      />

      {isLoading ? (
        <LoadingState />
      ) : filtered.length === 0 ? (
        <EmptyState
          icon={<Building2 className="size-8" />}
          title={t("empty.title")}
          description={t("empty.description")}
        />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((coop) => (
            <CooperativeCard key={String(coop.id)} cooperative={coop} />
          ))}
        </div>
      )}
    </div>
  )
}
